export default "__VITE_ASSET__Bn0DEkP9__"